import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import { green } from '@material-ui/core/colors';
import { withStyles, WithStyles } from '@material-ui/core/styles';


interface GreenCheckboxProps {
  name: string;
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

interface StyledCheckboxProps extends GreenCheckboxProps, WithStyles<typeof styles> {}

const styles = {
  root: {
    '&$checked': {
      color: green[600],
    },
  },
  checked: {},
};

const GreenCheckbox = withStyles(styles)(
  (props: StyledCheckboxProps) => (
    <Checkbox {...props} />
  )
);

export default GreenCheckbox;
